module.exports = __webpack_public_path__ + "img/big_1_60.c80e18b0.png";